import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { StoreInterface } from '../../store/types';
import classnames from 'classnames';
import { Order } from '../../services/exports/Interfaces';
import { ORDER_METHODS } from '../../services/exports/Constants';

interface Props {
  order: Order;
  className?: string;
}

export default function PickupInstruction(props: Props) {
  const { i18n } = useTranslation();

  const { company } = useSelector((state: StoreInterface) => state.initialData);

  const { order, className } = props;

  const text = i18n.language === 'de' ? company?.pickup_customer_message_de : company?.pickup_customer_message_en;

  return (
    order.method === ORDER_METHODS.PICKUP &&
    Boolean(text) && (
      <div className={classnames('p-md rounded-lg bg-[#FDF4EA]', className)}>
        <p className="text-sm">{text}</p>
      </div>
    )
  );
}
